module.exports = __webpack_public_path__ + "static/media/28.b4953a24.svg";